// Constantes para o módulo de postes de iluminação

export const STATUS_POSTE = {
  FUNCIONANDO: 'Funcionando',
  ALERTA: 'Alerta',
  DEFEITO: 'Defeito'
};

export const STATUS_COLORS = {
  [STATUS_POSTE.FUNCIONANDO]: '#4caf50', // Verde
  [STATUS_POSTE.ALERTA]: '#ff9800',      // Amarelo/Laranja
  [STATUS_POSTE.DEFEITO]: '#f44336'      // Vermelho
};

export const STATUS_ICONS = {
  [STATUS_POSTE.FUNCIONANDO]: '🟢',
  [STATUS_POSTE.ALERTA]: '🟡',
  [STATUS_POSTE.DEFEITO]: '🔴'
};

export const TIPOS_LAMPADA = [
  'LED',
  'Vapor de Sódio',
  'Vapor de Mercúrio',
  'Fluorescente',
  'Halógena',
  'Incandescente'
];

export const POTENCIAS_LAMPADA = [
  '50W',
  '70W',
  '100W',
  '150W',
  '200W',
  '250W',
  '400W'
];

export const ALTURAS_POSTE = [
  '4m',
  '6m',
  '8m',
  '10m',
  '12m',
  '15m'
];

export const CORES_MAPA = {
  [STATUS_POSTE.FUNCIONANDO]: '#4caf50',
  [STATUS_POSTE.ALERTA]: '#ff9800',
  [STATUS_POSTE.DEFEITO]: '#f44336'
};